import React from "react";
import { Link } from "react-router-dom";
import { ClipboardList, Activity, Bell, ChevronRight } from "lucide-react";

/**
 * Big finger-friendly quick-launch tiles for the three most-used field
 * actions. Optimised for phone-in-hand usage — 44px+ tap targets, high
 * contrast, and a compact desktop fallback so it doesn't hog space on
 * the operations dashboard.
 *
 * Only rendered inside the Dashboard, so haulers/drivers/receivers (who
 * don't see /dashboard) aren't affected. This is for dispatchers, admins,
 * PMs, and compliance officers using their phones between meetings.
 */

const TILES = [
  {
    to: "/loads",
    label: "Loads",
    sub: "Manifest, BOL, status",
    icon: ClipboardList,
    testid: "field-tile-loads",
  },
  {
    to: "/tracking",
    label: "Live Tracking",
    sub: "Real-time fleet map",
    icon: Activity,
    testid: "field-tile-tracking",
  },
  {
    to: "/notifications",
    label: "Notifications",
    sub: "Alerts inbox",
    icon: Bell,
    testid: "field-tile-notifications",
  },
];

export default function FieldOpsQuickLaunch() {
  return (
    <section className="mb-6" data-testid="field-ops-quick-launch">
      <div className="label-caps mb-3 text-gray-500">Field Ops</div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {TILES.map((tile) => {
          const Icon = tile.icon;
          return (
            <Link
              key={tile.to}
              to={tile.to}
              data-testid={tile.testid}
              className="group relative bg-gray-900 hover:bg-black text-white p-5 flex items-center gap-4 min-h-16 border-l-4 border-orange-500 transition-colors active:scale-[0.99]"
            >
              <div className="w-11 h-11 bg-orange-500 flex items-center justify-center flex-shrink-0">
                <Icon className="w-5 h-5" strokeWidth={2.5} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display font-bold text-lg leading-tight">
                  {tile.label}
                </div>
                <div className="text-xs text-gray-400 mt-0.5">{tile.sub}</div>
              </div>
              <ChevronRight
                className="w-5 h-5 text-gray-500 group-hover:text-white group-hover:translate-x-1 transition-all flex-shrink-0"
                strokeWidth={2}
              />
            </Link>
          );
        })}
      </div>
    </section>
  );
}
